
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useAuthGuard } from "@/hooks/useAuthGuard";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Hook for creating test resumes
 */
export const useTestResume = () => {
  const { toast } = useToast();
  const { ensureAuthenticated, user } = useAuthGuard();
  const queryClient = useQueryClient();

  const handleCreateTestResume = async () => {
    if (!ensureAuthenticated()) return;

    try {
      const { data, error } = await supabase
        .from("resumes")
        .insert({
          user_id: user.id,
          title: `Test Resume ${new Date().toLocaleString()}`,
          status: 'completed',
          content: 'This is a test resume created for demonstration purposes.',
          is_original: true // Mark test resumes as original so they appear in the dropdown
        })
        .select();

      if (error) throw error;

      toast({
        title: "Test Resume Created",
        description: "A new test resume has been added to your saved resumes."
      });

      // Invalidate all resume-related queries to ensure UI is updated
      queryClient.invalidateQueries({ queryKey: ["resumes"] });
    } catch (err: any) {
      toast({
        title: "Error Creating Resume",
        description: err.message,
        variant: "destructive"
      });
    }
  };

  return { handleCreateTestResume };
};
